<!--
  Anmeldung im Kundenbereich.

  Eine Seite, zwei Felder, ein Knopf. Kein „Registrieren" — Zugänge legt
  IT-Service Karsten Fischer an; ein Selbstregistrierungsformular würde hier nur Verwirrung und
  Karteileichen erzeugen.
-->
<script lang="ts">
  import { sitzung } from '../lib/sitzung.svelte.ts';

  let email = $state('');
  let passwort = $state('');
  let fehler = $state<string | null>(null);
  let laeuft = $state(false);

  async function anmelden(ereignis: SubmitEvent): Promise<void> {
    ereignis.preventDefault();
    laeuft = true;
    fehler = null;
    try {
      await sitzung.anmelden(email.trim(), passwort);
    } catch (f) {
      fehler = f instanceof Error ? f.message : 'Anmeldung fehlgeschlagen';
    } finally {
      laeuft = false;
    }
  }
</script>

<div class="anmeldeseite">
  <h1><span class="tb-wordmark">IT-Service Karsten Fischer</span></h1>
  <p class="leise">Ihr persönlicher Kundenbereich</p>

  <div class="karte">
    {#if fehler}<p class="fehler">{fehler}</p>{/if}

    <form onsubmit={anmelden}>
      <label for="email">E-Mail-Adresse</label>
      <input id="email" type="email" autocomplete="username" bind:value={email} required />

      <label for="passwort">Passwort</label>
      <input
        id="passwort"
        type="password"
        autocomplete="current-password"
        bind:value={passwort}
        required
      />

      <div class="knopfreihe">
        <button type="submit" disabled={laeuft || !email.trim() || !passwort}>
          {laeuft ? 'Einen Moment …' : 'Anmelden'}
        </button>
      </div>
    </form>
  </div>

  <p class="leise">
    Sie haben noch keinen Zugang oder Ihr Passwort vergessen? Rufen Sie uns an, wir schicken Ihnen
    einen neuen Einladungslink.
  </p>
</div>
